import Attraction from '@/views/home/attraction/Attraction';
import CreateAttraction from '@/views/home/attraction/CreateAttraction';
import auth from '@/routers/middlewares/auth';
import superadmin from '@/routers/middlewares/superadmin';

export default [{
        path: '/home/attraction',
        name: 'Attraction',
        component: Attraction,
        meta: {
            middleware: [auth, superadmin]
        }
    },
    {
        path: '/home/attraction/create',
        name: 'Create Attraction',
        component: CreateAttraction,
        meta: {
            middleware: [auth, superadmin]
        }
    },
    {
        path: '/home/attraction/edit/:id',
        name: 'Edit Attraction',
        component: CreateAttraction,
        meta: {
            middleware: [auth, superadmin]
        }
    }
];